import { Component } from "react";

// Prevents any uncaught render error from white-screening the whole app.
// Auto-recovers a few times (transient data glitches), then offers a reload.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, retries: 0 };
    this._timer = null;
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info?.componentStack);
    if (this.state.retries < 3) {
      this._timer = setTimeout(() => {
        this.setState((s) => ({ hasError: false, retries: s.retries + 1 }));
      }, 1200);
    }
  }

  componentWillUnmount() {
    if (this._timer) clearTimeout(this._timer);
  }

  render() {
    if (this.state.hasError) {
      const exhausted = this.state.retries >= 3;
      return (
        <div
          className="min-h-screen bg-black text-zinc-400 flex flex-col items-center justify-center gap-4 text-[11px] uppercase tracking-widest"
          data-testid="app-error-boundary"
        >
          <span>{exhausted ? "Terminal hiccup" : "Recovering…"}</span>
          {exhausted && (
            <button
              onClick={() => window.location.reload()}
              className="border border-zinc-700 px-4 py-2 hover:border-amber-term hover:text-amber-term transition-colors"
              data-testid="error-reload-btn"
            >
              Reload terminal
            </button>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
